var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"leading-tighter"},[_c('span',{staticClass:"heading-font text-sm uppercase font-normal mg-color-secondary-lighter"},[_vm._v(_vm._s(_vm.display_date))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":_vm.post.link}},[_c('span',{staticClass:"text-lg leading-tight"},[_vm._v(_vm._s(_vm.title))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1622b40f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/js/vue-components/ml-news-item.vue
// module id = 385
// module chunks = 0